import { render, staticRenderFns } from "./employer-performance.vue?vue&type=template&id=37a8fd82"
import script from "./employer-performance.vue?vue&type=script&lang=js"
export * from "./employer-performance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports